import React, { Component } from 'react';
import {
  Card, CardImg, CardText, CardBody,
  CardTitle, CardSubtitle, Button
} from 'reactstrap';
import { FaUserFriends } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";

import authService from './api-authorization/AuthorizeService';
import { ApplicationPaths } from './api-authorization/ApiAuthorizationConstants';
import axios from 'axios';
export class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      role: null
    };

  }
  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState2());
    this.populateState2();
   
  }
  async populateState2() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
   
      if (user !== null) {
          this.GetUserCurrent(user.sub)
      }
   
  }
  GetUserCurrent(idEmpleado) {

    axios.get('/Api/Usuario/UsuarioRole?idEmpleado=' + idEmpleado)
      .then(response => {
        console.log(response);
        console.log(response.data);
        this.setState({ role: response.data[0].role })
        console.log(this.state)

      })
      .catch(function (error) {
        console.log(error);
      })

  }

  render() {
      if (this.state.role == "Admin" ) {
      return (
          <div>
            


          <h1>Gesti&oacute;n de Solicitudes de Cr&eacute;ditos</h1>
         <hr/>
          <div className="row">
            <div className="col-sm-12 col-lg-3 col-md-3 col-xs-12">
              <Card>
                <div className="col-12 alinearImagen">
                <CardImg top width="100%" className="imagenRedonda" src="/images/settings.png" alt="Administración" />
                </div>
              <CardBody>
                  <CardTitle>Administración</CardTitle>
                  <CardText>Usuarios, Empresas, Catálogos.</CardText>
                  <Button className=" irDerecha" href='/identity/admin/Index'>Ir <IoIosArrowForward /></Button>
              </CardBody>
              </Card>
            </div>
            <div className="col-sm-12 col-lg-3 col-md-3 col-xs-12">
              <Card>
                <div className="col-12 alinearImagen">
                <CardImg top width="100%" className="imagenRedonda" src="/images/revision-del-cliente.png" alt="Solicitudes" />
                </div>
                <CardBody>
                  <CardTitle>Solicitudes</CardTitle>
                  
                  <CardText className="TextoSubtituloHome">Listado de las solicitudes de crédito.</CardText>
                  <Button className=" irDerecha" href='/RevisarCreditosAdmin'>Ir  <IoIosArrowForward /></Button>
                </CardBody>
              </Card>
            </div>
          </div>
       
        </div>
      );
      }
      else if (this.state.role == "Vendedor" || this.state.role == "Analista de Crédito") {
          return (
              <div>
                  <h1>Gesti&oacute;n de Solicitudes de Cr&eacute;ditos</h1>
                  <div className="row">
                      <div className="col-sm-12 col-lg-3 col-md-4 col-xs-12">
                          <Card>
                              <div className="col-12 alinearImagen">
                                  <CardImg top width="100%" className="imagenRedonda" src="/images/grupo.png" alt="Solicitudes" />
                              </div>
                              <CardBody>
                                  <CardTitle>Solicitudes</CardTitle>

                                  <CardText className="TextoSubtituloHome">Creación y listado de solicitudes de crédito.</CardText>
                                  <Button className=" irDerecha" href='/RevisarCreditosAdmin'>Ir  <IoIosArrowForward /></Button>
                              </CardBody>
                          </Card>
                      </div>
                  </div>
              </div>
          );
      }
      else {
      return (
        <div>
          <h1>Gesti&oacute;n de Solicitudes de Cr&eacute;ditos</h1>
          <div className="row">
            <div className="col-sm-12 col-lg-3 col-md-4 col-xs-12">
              <Card>
                <div className="col-12 alinearImagen">
                  <CardImg top width="100%" className="imagenRedonda" src="/images/grupo.png" alt="Solicitudes" />
                </div>
                <CardBody>
                  <CardTitle>Solicitudes</CardTitle>

                  <CardText className="TextoSubtituloHome">Creación y listado de solicitudes de crédito.</CardText>
                  <Button className=" irDerecha" href='/VerCreditos'>Ir <IoIosArrowForward /></Button>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      );
    }
  }
}
